import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Instance } from 'mobx-state-tree';
import { inject } from 'mobx-react';
import * as React from 'react';
import { Button, ButtonGroup, Colors, Icon, InputGroup, Intent, Position } from '@blueprintjs/core';
import { MAP, RESET, SEND_MESSAGE } from '@blueprintjs/icons/lib/esm/generated/iconNames';
import { Page, TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { Pharmacy } from '../../store/models/Pharmacy';
import {
  AuthenticationStore,
  SecretariatStore,
  UserStore,
  GroupStore,
  AnchorStore,
  UiStore,
  PharmacyStatusStore,
  PharmacyStore,
  PharmacyDetailedStore,
} from '../../store';
import { Select } from 'antd';
import { MessageDialog } from '../common/MessageDialog';
import { MessageStore } from '../../store/MessageStore';
import { Tooltip2 } from '@blueprintjs/popover2';
import { TranslatedMessage } from '../common/translation';
import {
  DataGrid,
  Column,
  Button as DGButton,
  Sorting,
  Scrolling,
  SearchPanel,
  DataGridTypes,
  Export,
  FilterRow,
  FilterPanel,
  HeaderFilter,
  GroupPanel,
  Grouping,
  ColumnChooser,
  Pager,
  Paging,
  Item,
  Toolbar
} from 'devextreme-react/data-grid';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import DataSource from 'devextreme/data/data_source';
import { PharmacyStatusCell } from '../common/grid/PharmacyStatusCell';
import { PHARMACY_STATUS_AC, PHARMACY_STATUS_TC, PHARMACY_STATUS_PC } from '../../common/constants/pharmacyStatusConstants';
import { boolean } from 'mobx-state-tree/dist/internal';

interface PharmaciesListProps extends WithTranslateProps {
  filter: string;
  navigate: (url: string) => void;
  pharmaciesList: Array<Instance<typeof Pharmacy>>;
  showOnMap: () => void;
  reloadPharmacyList: () => void;
  activeFilter: string;
  levelFilter: string;
  secretariatFilter: number | undefined;
  setActiveFilter: (filter: string) => void;
  setLevelFilter: (filter: string) => void;
  setSecretariatFilter: (filter: number | undefined) => void;
  UserStore?: Instance<typeof UserStore>;
  UiStore?: Instance<typeof UiStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  GroupStore?: Instance<typeof GroupStore>;
  AnchorStore?: Instance<typeof AnchorStore>;
  MessageStore?: Instance<typeof MessageStore>;
  PharmacyStatusStore?: Instance<typeof PharmacyStatusStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
}

interface PharmacyListState {
  currentGroupFilter: string;
  isMessageDialogOpen: boolean;
  dataSource: DataSource | undefined;
  buttonFilters: any[];
  gridFilter: any[]
  globalFilterValue: any;
}

@inject('UserStore')
@inject('AuthenticationStore')
@inject('SecretariatStore')
@inject('GroupStore')
@inject('AnchorStore')
@inject('UiStore')
@inject('MessageStore')
@inject('PharmacyStore')
@inject('PharmacyStatusStore')
@inject('PharmacyDetailedStore')
class PharmaciesList extends React.Component<PharmaciesListProps, PharmacyListState> {
  _isMounted = false;
  state = {
    currentGroupFilter: '',
    isMessageDialogOpen: false,
    dataSource: undefined,
    buttonFilters: [],
    gridFilter: [],
    globalFilterValue: []
  };

  async componentDidMount() {
    this._isMounted = true;
    await this.props.GroupStore!.checkListLoaded();
    await this.props.AnchorStore!.checkListLoaded();
    await this.props.UserStore!.checkListLoaded();
    await this.props.PharmacyStatusStore!.checkListLoaded();
    //await this.props.PharmacyStore!.search({ withUser: true });
    if (this.props.AuthenticationStore!.isSuperAdmin) {
      var secretariatId = this.getSecretariatId();
      this.props.setSecretariatFilter(secretariatId);
    }

    // const dataSource = new DataSource({
    //   store: { type: 'array', key: 'pharmacyId', data: this.props.pharmaciesList },
    //   langParams: {
    //     locale: 'fr',
    //     collatorOptions: {
    //       sensitivity: 'base',
    //     },
    //   },
    // });
    const dataSource = await this.buildGridData();
      this.resetSecretariatFilter();
      if (this._isMounted) {
        this.setState({ dataSource });
      }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  private onRowDoubleClicked = (ev) => {
    this.props.navigate(`${Page.PharmacyPage}/${ev.data.pharmacyId}`);
  };

  private goToUser = async (e) => {
    const pharmacy = await this.props.PharmacyDetailedStore!.getByIdWithDetails(parseInt(e.row.data.pharmacyId));
    if (pharmacy[0] === undefined) return;

    this.props.navigate(`${Page.UserPage}/${pharmacy[0].userId}`);
  }

  buildGridData = async () => {
    const { activeFilter, levelFilter, secretariatFilter } = this.props;
    // const { statusFilter, levelFilter2 } = this.state;
    if (this.props.AnchorStore.dataList.length == 0) {
      await this.props.AnchorStore!.loadList();
    }
    let statuses = this.props.PharmacyStatusStore!.dataList;

    let activeStatus = statuses.find((s) => s.code == PHARMACY_STATUS_AC)!;

    var data = this.props.PharmacyStore!.dataList//.filter(ph => ph.level > 0) //this.props.pharmaciesList//.filter(ph => ph.level > 0)
      .map((p) => ({
        pharmacyId: p.pharmacyId,
        apbNumber: p.apbNumber,
        name: p.name,
        phone: p.phone,
        address: p.address,
        zipCode: p.zipCode,
        city: p.city,
        level: p.level,
        statusId: p.statusId,
        statusName: p.statusName, //status!.name,
        email: p.email, //p.user === undefined ? '' : p.user.email,
        username: p.firstname + ' ' + p.lastname, //p.user === undefined ? 'unknown' : p.user.firstName + ' ' + p.user.lastName,
        zone: p.zoneId,
        density: p.density,
        anchor: p.anchorName === undefined ? '' : p.anchorName.name, 
        group: p.group === undefined ? '' : p.group.name,
        secretariatId: p.secretariatId,
        secretariat: p.secretariat === undefined ? '': p.secretariat.code,
      }));

    return new DataSource({
      store: { type: 'array', key: 'pharmacyId', data: data },
      langParams: {
        locale: 'fr',
        collatorOptions: {
          sensitivity: 'base',
        },
      },
    });
  };

  getEmail = (apbNumber: string) => {
    const user = this.props.UserStore!.dataList.find((user) => user.userName == apbNumber);
    return user ? user!.email! : '';
  }

  getPharmacyUser = (apbNumber: string) => {
    const user = this.props.UserStore!.dataList.find((user) => user.userName == apbNumber);
    return user ? user!.firstName! + ' ' + user!.lastName! : 'unknown';
  }

  newMessage = () => {
    this.setState({ isMessageDialogOpen: true });
  };

  saveMessage = async (data: any) => {
    this.setState({ isMessageDialogOpen: false });
    await this.props.MessageStore!.sendMessage(data);
  };

  sendPreview = (data: any) => {
    return (this.props.MessageStore!.sendPreview(data) as unknown) as boolean;
  };

  getSecretariatId = () => {
    if (this.props.AuthenticationStore!.isSuperAdmin)
      return this.props.SecretariatStore!.selectedSecretariatId === 0
        ? undefined
        : this.props.SecretariatStore!.selectedSecretariatId;
    if (this.props.AuthenticationStore!.isSecretariat) return this.props.AuthenticationStore!.secretariatId!;
    return undefined;
  };

  onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Pharmacies_list.xlsx');
      });
    });
  };

  displayPharmacyStatusCell = (params: any) => {
    var pharmacyStatusId = params.row.data.statusId;
    if (pharmacyStatusId === undefined) return <></>;

    const pharmacyStatus = this.getPharmacyStatus(pharmacyStatusId);
    if (pharmacyStatus === undefined) return <></>;

    return <PharmacyStatusCell pharmacyStatus={pharmacyStatus} />;
  };

  getPharmacyStatus = (statusId: number) => {
    return this.props.PharmacyStatusStore!.dataList.find(
      (ps) => ps.pharmacyStatusId === statusId,
    );
  }

  getSecretariatCode = () => {
    const secretariatList = this.props.SecretariatStore!.dataList;
    var secretariatId = this.props.secretariatFilter;

    if (secretariatId === undefined || secretariatId == 0) return 'All';
    return this.props.AuthenticationStore!.isSuperAdmin
      ? (secretariatList.find((s) => s.secretariatId === secretariatId)!.code)
      : this.props.secretariatFilter === 0 ||
        secretariatList === undefined ||
        secretariatList.length === 0
        ? undefined
        : this.props.secretariatFilter === undefined
          ? secretariatList.sort((s) => s.secretariatId)[0].code
          : secretariatList.find((s) => s.secretariatId === this.props.secretariatFilter)!.code
  }

  private dataGridRef = React.createRef<DataGrid>();

  private isInternalChange: boolean = false;



  // applyFilter = (value: any) => {
  //   this.isInternalChange = true;
  //   this.setState({ globalFilterValue: value || []});
  // }

  private statusFilter = [];

  toggleFilterOld = (newFilter: any) => {
    this.setState((prevState) => {
      if (this.statusFilter.length == 0) {
        this.statusFilter = newFilter;
      } else if (this.statusFilter.every((val, index) => val === newFilter[index])) {
        this.statusFilter = [];
        return { gridFilter: prevState.gridFilter };
      } else {
        this.statusFilter = newFilter;
      }
      const current = prevState.gridFilter;
      if (Array.isArray(current) && current.every((val, index) => val === newFilter[index])) {
        return { gridFilter: newFilter };
      } else if (Array.isArray(current) && current.includes(newFilter)) {
        return { gridFilter: current.filter((f: any) => f !== newFilter) };
      } else if (current.length > 0) {
        return { gridFilter: [current, "and", newFilter] };
      } else {
        return { gridFilter: newFilter };
      }
    });
  };

  toggleFilter = (newFilter: any) => {
    this.setState((prevState) => {

      const current = prevState.gridFilter;
      if (Array.isArray(current)) {
        if (current.length == 0) {
          return { gridFilter: newFilter};
        } else {
          if (Array.isArray(current[0])) {
            if (this.removeEntry(current, newFilter)) {
              return { gridFilter: current }
            } else {
              current.push("and", newFilter);
              return { gridFilter:  current };
            }
          } else {
            if (current[0] == newFilter[0]) {
              return { gridFilter: newFilter };
            } else {
              return { gridFilter: [current, "and", newFilter]};
            }
          }
        }
      } else {
        return { gridFilter: current };
      }
    });
  };

  removeEntry = (current: any[], item) => {
    // current est un tableau de filtres avec des "and"
    for (let index = 0; index < current.length; index++) {
      const element = current[index];

      if (Array.isArray(element) && element[0] == item[0]) {
        current[index] = item;
        return true;
      } else if (!Array.isArray(element) && element === item[0]) {
        current.splice(index, 1);
      }
    }
    return false;
  }

  replaceEntry = (current: any[], item) => {
    for (let index = 0; index < current.length; index++) {
      const element = current[index];

      if (Array.isArray(element) && element[0] === item[0]) {
        current.splice(index, 1);
        return true;
      } else if (!Array.isArray(element) && element === item[0]) {
        current.splice(index, 3);
        return true;
      }
    }
    return false;
  }

  resetFilters = () => {
    this.setState({ buttonFilters: [], gridFilter: [] });
    const secretariatId = this.props.AuthenticationStore!.secretariatId;
    if (secretariatId != null) {
      const secretariatList = this.props.SecretariatStore!.dataList;
      this.toggleFilter(["secretariat", "=", secretariatList.find((s) => s.secretariatId == secretariatId)!.code]);
      this.props.setSecretariatFilter(secretariatId);
    }
  };

  resetSecretariatFilter = () => {
    const secretariatId = this.props.AuthenticationStore!.secretariatId;
    if (secretariatId != null) {
      const secretariatList = this.props.SecretariatStore!.dataList;
      this.toggleFilter(["secretariat", "=", secretariatList.find((s) => s.secretariatId == secretariatId)!.code]);
      this.props.setSecretariatFilter(secretariatId);
    }
    
  }

  handleGridFilterChange = (e) => {
  if (e.name === "filterValue") {
    if (this.state.gridFilter != e.value) {
      this.setState({ gridFilter: e.value || [] });
    }
  }
  }

  // Combine les deux filtres
  get combinedFilter() {
    const { buttonFilters, gridFilter } = this.state;
    if (buttonFilters.length === 0) return gridFilter;
    if (gridFilter.length === 0) return buttonFilters;
    return [buttonFilters, "and", gridFilter];
  }

  render() {
    const { showOnMap, reloadPharmacyList, setActiveFilter, setLevelFilter, translate , activeFilter, secretariatFilter, levelFilter } = this.props;
    // const { statusFilter, levelFilter2 } = this.state;

    const secretariatList = this.props.SecretariatStore!.dataList;
    let statuses = this.props.PharmacyStatusStore!.dataList;

    let activeStatus = statuses.find((s) => s.code == PHARMACY_STATUS_AC)!;
    let tcStatus = statuses.find((s) => s.code == PHARMACY_STATUS_TC)!;
    let pcStatus = statuses.find((s) => s.code == PHARMACY_STATUS_PC)!;

    return (
      <Container>
        <MessageDialog
          isOpen={this.state.isMessageDialogOpen}
          isPreloaded={false}
          onClose={() => this.setState({ isMessageDialogOpen: false })}
          isTest={false}
          save={this.saveMessage}
          pharmacyId={undefined}
          secretariatId={this.getSecretariatId()}
          pharmacyList={this.props.pharmaciesList}
          groupList={this.props.GroupStore!.dataList}
          translate={translate}
          isSecretariat={this.props.AuthenticationStore!.isSecretariat}
          canPreview={
            this.props.AuthenticationStore!.isAdmin ||
            this.props.AuthenticationStore!.isSuperAdmin ||
            this.props.AuthenticationStore!.isSecretariat
          }
          onPreviewClick={this.sendPreview}
        />
        <DivLine>
          <DivCenter style={{ width: '100%' }}>
            {/* {this.props.AuthenticationStore!.isSecretariat && (
              <SimpleTextFormContent label={TLCode.PHARMACIES_Secretariats}>
                <DivLine>
                  <div style={{ width: '305px' }}>
                    <Select
                      defaultValue={this.getSecretariatCode()}
                      style={{ width: 300 }}
                      onChange={(code) => {
                        const selectedSecretariatId =
                          code === 'All'
                            ? undefined
                            : (secretariatList.find((s) => s.code === code)!.secretariatId as number);
                        this.props.setSecretariatFilter(selectedSecretariatId);
                        this.toggleFilter(["secretariat", "=", secretariatList.find((s) => s.code === code)!.code])
                      }}
                    >
                      {secretariatList &&
                        secretariatList
                          .map((sec) => (
                            <Select.Option key={sec.code} value={sec.code}>
                              {sec.code}
                            </Select.Option>
                          ))
                          .concat(
                            <Select.Option key={'All'} value={'All'}>
                              {'All'}
                            </Select.Option>,
                          )}
                    </Select>
                  </div>
                </DivLine>
              </SimpleTextFormContent>
            )} */}
            {this.props.AuthenticationStore!.isSecretariat && (
              <>              
              <ButtonGroup>
                <Button
                  text={this.props.translate(TLCode.PHARMACIES_MySecretariat)}
                  onClick={() => this.resetSecretariatFilter()}
                  // active={this.state.statusFilter === 'AC'}
                />
              </ButtonGroup>
              &nbsp;&nbsp;
              </>
            )}
            <SimpleTextFormContent label={TLCode.PHARMACIES_ActivityStatus}>
              <ButtonGroup>
                <Button
                  text={'AC'}
                  onClick={() => this.toggleFilter(["statusName", "=", 'active'])}
                  // active={this.state.statusFilter === 'AC'}
                />
                <Button
                  text={'TC'}
                  onClick={() => this.toggleFilter(["statusName", "=", 'temporarily closed'])}
                  // active={this.state.statusFilter === 'TC'}
                />
                <Button
                  text={'PC'}
                  onClick={() => this.toggleFilter(["statusName", "=", 'permanently closed'])}
                  // active={this.state.statusFilter === 'PC'}
                />
                {/* <Button
                  text={'Tous'}
                  onClick={() => this.resetFilters()}
                  // active={this.state.statusFilter === 'PC'}
                /> */}
                {/* <Button
                  text={translate(TLCode.PHARMACIES_Active)}
                  onClick={() => setActiveFilter('active')}
                  active={this.props.activeFilter === 'active'}
                />
                <Button
                  text={translate(TLCode.PHARMACIES_Inactive)}
                  onClick={() => setActiveFilter('inactive')}
                  active={this.props.activeFilter === 'inactive'}
                />
                <Button
                  text={translate(TLCode.PHARMACIES_All_M)}
                  onClick={() => setActiveFilter('both')}
                  active={this.props.activeFilter === 'both'}
                /> */}
              </ButtonGroup>
            </SimpleTextFormContent>
            <SimpleTextFormContent label={TLCode.PHARMACIES_Level}>
              <ButtonGroup>
                <Button
                  text={'3'}
                  onClick={() => this.toggleFilter(["level", "=", 3])}
                  // active={this.state.levelFilter2 === '3'}
                />
                <Button
                  text={'1'}
                  onClick={() => this.toggleFilter(["level", "=", 1])}
                  // active={this.state.levelFilter2 === '1'}
                />
                <Button
                  text={'0'}
                  onClick={() => this.toggleFilter(["level", "=", 0])}
                  // active={this.state.levelFilter2 === '0'}
                />
                &nbsp;&nbsp;
                &nbsp;&nbsp;
                &nbsp;&nbsp;
                <Button
                  text={'Reset'}
                  onClick={() => this.resetFilters()}
                  // active={this.state.levelFilter2 === 'all'}
                />

                {/* <Button
                  text={translate(TLCode.PHARMACIES_Three)}
                  onClick={() => setLevelFilter('three')}
                  active={this.props.levelFilter === 'three'}
                />
                <Button
                  text={translate(TLCode.PHARMACIES_One)}
                  onClick={() => setLevelFilter('one')}
                  active={this.props.levelFilter === 'one'}
                />
                <Button
                  text={translate(TLCode.PHARMACIES_Zero)}
                  onClick={() => setLevelFilter('zero')}
                  active={this.props.levelFilter === 'zero'}
                />
                <Button
                  text={translate(TLCode.PHARMACIES_All_M)}
                  onClick={() => setLevelFilter('all')}
                  active={this.props.levelFilter === 'all'}
                /> */}
              </ButtonGroup>
            </SimpleTextFormContent>
          </DivCenter>
          <DivRight>
            <Button
              icon={MAP}
              onClick={showOnMap}
              text={this.props.translate(TLCode.DutiesShowWideMap_Short)}
              style={{ width: '80px' }}
            />
            <Button
              icon={RESET}
              onClick={reloadPharmacyList}
              text={this.props.translate(TLCode.PHARMACIES_LoadList)}
              style={{ width: '140px' }}
            />
            <Button
              icon={SEND_MESSAGE}
              text={translate(TLCode.MESSAGE_NewMessage)}
              intent={Intent.PRIMARY}
              onClick={() => this.newMessage()}
              style={{ width: '170px' }}
              hidden={
                !(
                  this.props.AuthenticationStore!.isSecretariat ||
                  this.props.AuthenticationStore!.isAdmin ||
                  this.props.AuthenticationStore!.isSuperAdmin
                )
              }
            />
          </DivRight>
        </DivLine>
        <DivLine>
          <Tooltip2
            content={
              <div style={{ maxWidth: '200px' }}>
                <TranslatedMessage id={TLCode.PHARMACIES_Help} />
              </div>
            }
            position={Position.RIGHT}
          >
            <Icon icon="help" />
          </Tooltip2>
        </DivLine>
        <DataGrid
          id="pharmaciesList"
          ref={this.dataGridRef}
          filterSyncEnabled
          filterValue={this.combinedFilter}
          dataSource={this.state.dataSource}
          onOptionChanged={this.handleGridFilterChange}
          showBorders
          rowAlternationEnabled={true}
          onRowPrepared={(r) => {
            if (r.rowType === 'data') {
              if (
                this.props.AuthenticationStore!.isSecretariat &&
                (!r.data.secretariatId ||
                  (r.data.secretariatId && r.data.secretariatId !== this.props.AuthenticationStore!.secretariatId))
              )
                r.rowElement.style.backgroundColor = Colors.LIGHT_GRAY1;
              else r.rowElement.style.backgroundColor = Colors.WHITE;
            }
          }}
          onRowClick={this.onRowDoubleClicked}
          onExporting={this.onExporting}
          allowColumnResizing
          columnHidingEnabled={true}
          onContentReady={(e) => {
            var rows = e.component.getVisibleRows();
            var pharmacyIds = rows.filter((r) => r.data.pharmacyId !== undefined).map((r) => r.data.pharmacyId);
            if (pharmacyIds.length > 0) this.props.UiStore!.setFilteredAndSortedPharmacies(pharmacyIds);
          }}
          stateStoring={{
            enabled: true,
            type: 'sessionStorage',
            storageKey: 'pharmaciesListGrid',
          }}
          width={'100%'}
          columnAutoWidth
        >
          <Export enabled={true} texts={{ exportAll: translate(TLCode.GRID_EXCEL_EXPORT) }} />
          {/* <Scrolling mode="virtual" /> */}
          {/* <Scrolling rowRenderingMode="virtual" /> */}
          <Sorting mode="multiple" />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <FilterRow visible={true} applyFilter={'auto'} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={false} width={400} highlightSearchText={false} />
          <Grouping autoExpandAll={false} />
          <Toolbar>
            <Item location="before" locateInMenu="never" name="groupPanel" />
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
            <Item name="searchPanel" />
            <Item location="after" locateInMenu="never">
              <Tooltip2
                content={
                  <div style={{ maxWidth: '200px' }}>
                    <TranslatedMessage id={TLCode.PHARMACIES_Search_Help} />
                  </div>
                }
                position={Position.RIGHT}
              >
                <Icon icon="help" />
              </Tooltip2>
            </Item>
          </Toolbar>
          <ColumnChooser enabled={true} />
          <Pager
            visible={true}
            allowedPageSizes={[20, 50, 100]}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />
          <Paging defaultPageSize={20} />
          <Column dataType="number" dataField="level" caption="" width={40} sortIndex={0} sortOrder="desc" allowSearch={false} />
          <Column
            dataType="number"
            dataField="apbNumber"
            caption={translate(TLCode.PHARMACIES_ApbNum)}
            width={80}
            defaultSortOrder="asc"
            sortIndex={2}
            allowSearch={true}
          />
          <Column
            dataType="string"
            dataField="name"
            caption={translate(TLCode.PHARMACIES_PharmacyName)}
            allowSearch={true}
          />
          <Column
            dataType="string"
            dataField="address"
            caption={translate(TLCode.PHARMACIES_Address)}
            hidingPriority={4}
            allowSearch={true}
          />
          <Column
            dataType="string"
            dataField="zipCode"
            caption={translate(TLCode.PHARMACIES_ZipCode)}
            width={55}
            hidingPriority={3}
            allowSearch={false}
          />
          <Column
            dataType="string"
            dataField="city"
            caption={translate(TLCode.PHARMACIES_City)}
            width={160}
            hidingPriority={2}
            allowSearch={true}
          />
          <Column
            dataType="string"
            dataField="secretariat"
            caption={translate(TLCode.PHARMACIES_Secretariat)}
            allowSearch={false}
            width={85}
          />
          <Column
            dataType="string"
            dataField="group"
            caption={translate(TLCode.PHARMACIES_Group)}
            width={120}
            defaultSortOrder="asc"
            sortIndex={1}
            allowSearch={false}
          />
          <Column
            dataType="string"
            dataField="anchor"
            caption={translate(TLCode.PHARMACIES_Anchor)}
            width={120}
            allowSearch={false}
          />
          <Column
            dataType="string"
            dataField="username"
            caption={translate(TLCode.PHARMACIES_User)}
            width={180}
            hidingPriority={1}
            allowSearch={true}
          />
          <Column
            dataType="string"
            dataField="email"
            caption={translate(TLCode.Email)}
            width={180}
            hidingPriority={0}
            allowSearch={true}
          />
          <Column
            cellRender={this.displayPharmacyStatusCell}
            dataField="statusName"
            caption={translate(TLCode.PHARMACY_Status)}
            width={80}
            alignment="center"
            allowSearch={false}
          />
          <Column caption="Actions" type="buttons" width={60} allowSearch={false}>
            <DGButton
              hint={translate(TLCode.GENERAL_Edit)}
              icon={'edit'}
              onClick={(e) => {
                this.props.navigate(`${Page.PharmacyPage}/${e.row!.data.pharmacyId}`);
              }}
            />
            &nbsp;
            <DGButton
              hint={translate(TLCode.PHARMACY_Goto_User)}
              icon={'user'}
              onClick={this.goToUser}
            />

          </Column>
          <Pager
            visible={true}
            allowedPageSizes={[20, 50, 100, 500, 'all']}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />
          <Paging defaultPageSize={20} />
        </DataGrid>
      </Container>
    );
  }
}

export default withTranslate(PharmaciesList);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-right: 5%;
  padding-bottom: 5px;
`;

const DivCenter = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 5px;
  .bp3-form-content > div {
    display: flex;
    flex-direction: row;
    margin-right: 20px;
    .bp3-control {
      margin-top: 0;
      margin-right: 5px;
    }
  }
  .bp3-form-group {
    margin-bottom: 0;
  }
`;
const DivRight = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 5px;
  .bp3-button {
    margin-right: 3px;
  }
`;
